export enum BillingPolicy {
  SUM_HOURS = "Sum Hours" as any,
  SUM_HOURS_WITH_MINIMUM = "Sum Hours With Minimum" as any,
}
